import { weekMondayForDate, weekEndForStart } from './reportFilters';

export const ATTENDANCE_PERIODS = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'custom', label: 'Custom' },
];

export function todayYmd() {
  const d = new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(d);
  const y = parts.find((p) => p.type === 'year')?.value;
  const m = parts.find((p) => p.type === 'month')?.value;
  const day = parts.find((p) => p.type === 'day')?.value;
  return `${y}-${m}-${day}`;
}

export function currentMonthYmd() {
  return todayYmd().slice(0, 7);
}

export function shiftMonth(month, delta) {
  const [y, m] = month.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function formatMonthLabel(month) {
  const [y, m] = month.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleString('en-IN', { month: 'long', year: 'numeric' });
}

export function formatPeriodLabel(filters) {
  const { period, date, weekStart, month, from, to } = filters;
  if (period === 'day') return date;
  if (period === 'week') return `${weekStart} – ${weekEndForStart(weekStart)}`;
  if (period === 'month') return formatMonthLabel(month);
  if (period === 'custom') return `${from} – ${to}`;
  return '';
}

export function defaultAttendanceFilters() {
  const today = todayYmd();
  const month = currentMonthYmd();
  return {
    period: 'week',
    date: today,
    weekStart: weekMondayForDate(today),
    month,
    from: shiftMonth(month, -1) + '-01',
    to: today,
    batchId: '',
    studentId: '',
    teacherId: '',
    country: '',
    teamView: false,
  };
}

export function buildAttendanceQueryParams(filters) {
  const params = { period: filters.period };
  if (filters.period === 'day') params.date = filters.date;
  else if (filters.period === 'week') params.weekStart = filters.weekStart;
  else if (filters.period === 'month') params.month = filters.month;
  else if (filters.period === 'custom') {
    params.from = filters.from;
    params.to = filters.to;
  }
  if (filters.batchId) params.batchId = filters.batchId;
  if (filters.studentId) params.studentId = filters.studentId;
  if (filters.country) params.country = filters.country;
  if (filters.teamView) params.teamView = 'true';
  else if (filters.teacherId) params.teacherId = filters.teacherId;
  if (filters.page) params.page = String(filters.page);
  if (filters.pageSize) params.pageSize = String(filters.pageSize);
  return params;
}

export function monthOptions(count = 13) {
  const base = currentMonthYmd();
  const out = [];
  for (let i = 0; i < count; i += 1) out.push(shiftMonth(base, -i));
  return out;
}
